import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    margin: 0,
    minWidth: '100%',
  },
}));

export default useStyles;
